<template>
  <div class="admin-project-details-page" @click="handleOutsideClick">
    <div class="full-wrapper">
      <div class="main-custom-row">
        <div class="main-left">
          <div class="pro-top-info-box">
            <div class="custom-row">
              <div class="pro-top-img">
                <img
                  :src="projectDetail.avatarUrls?.['48x48']"
                  alt=""
                />
              </div>
              <div class="pro-top-content">
                <h1>{{ projectDetail.name }}</h1>
                <div class="pro-short-des">
                  <p>{{ projectDetail.description }}</p>
                </div>
                <div class="pro-link">
                  <a id="projectWebsiteLink" :href="projectDetail.url" target="_blank">{{ projectDetail.url }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="project-team-chat-section">
            <!-- <div class="custom-row">
              <ProjectTeamMembersList></ProjectTeamMembersList>
              <ProjectRecentChats></ProjectRecentChats>
            </div> -->
          </div>
          <div class="dashboard-project-status">
            <ProjectStatus></ProjectStatus>
          </div>
          <div class="dashboard-chart-2">
            <div class="custom-row">
              <Chart4 @open-issues-popup="handleOpenIssuesPopup" ref="chart4Ref"></Chart4>
              <Chart2></Chart2>
            </div>
          </div>
          <!-- <div class="recent-project-files">
            <ProjectRecentFiles></ProjectRecentFiles>
          </div> -->
          <!-- <div class="see-all-btn">
            <a
              href="employee-files.html"
              id="seeAllFilesLink"
              class="v1-button-outline"
            >
              {{ constants.SEE_ALL_FILES_LINK }}
            </a>
          </div> -->
        </div>
        <div class="main-right">
          <Issues ref="issuesRef"></Issues>
          <Activity ref="activityRef"></Activity>
        </div>
      </div>
    </div>
    <IssuePopup 
      :popup-data="popupData" 
      :is-visible="showIssuesPopup"
      @close="closeIssuesPopup"
    ></IssuePopup>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL } from "@/config/api.config";
import ProjectTeamMembersList from "@/components/lems-v1/projectTeamMembersList.vue";
import ProjectRecentChats from "@/components/lems-v1/projectRecentChats.vue";
import ProjectStatus from "@/components/lems-v1/projectStatus.vue";
import Chart4 from "@/components/lems-v1/chart4.vue";
import Chart2 from "@/components/lems-v1/chart2.vue";
import ProjectRecentFiles from "@/components/lems-v1/projectRecentFiles.vue";
import Issues from "@/components/lems-v1/issues.vue";
import Activity from "@/components/lems-v1/activity.vue";
import IssuePopup from "@/components/lems-v1/issuePopup.vue";

interface ProjectDetail {
  id: string;
  key: string;
  name: string;
  description: string;
  url: string;
  avatarUrls: {
    [key: string]: string;
  };
  lead: {
    displayName: string;
    avatarUrls: {
      [key: string]: string;
    };
  };
}

export default defineComponent({
  name: "ProjectDetail",
  components: {
    ProjectTeamMembersList,
    ProjectRecentChats,
    ProjectStatus,
    Chart4,
    Chart2,
    ProjectRecentFiles,
    Issues,
    Activity,
    IssuePopup,
  },
  data() {
    return {
      constants,
      projectDetail: {} as ProjectDetail,
      showIssuesPopup: false,
      popupData: {
        month: '',
        projectKey: '',
        created: 0,
        resolved: 0
      }
    };
  },
  props: {
      projectKey: {
        type: String,
        required: true,
      },
    },
  mounted() {
    this.getProjectDetails();
  },
  methods: {
    async getProjectDetails() {
      const username = localStorage.getItem("jira_user_username");
      if (!username || !this.projectKey) {
        return;
      }

      try {        
        const response = await axios.get(
          `${API_BASE_URL}/jira/project/${username}/${this.projectKey}/`
        );
        
        this.projectDetail = response.data.project;
        console.log("Project details:", this.projectDetail);
      } catch (error) {
        console.error("Error fetching project details:", error);
      } finally {
      }
    },
    handleOpenIssuesPopup(data: { month: string; projectKey: string; created: number; resolved: number }) {
      this.popupData = data;
      this.showIssuesPopup = true;
    },
    closeIssuesPopup() {
      this.showIssuesPopup = false;
    },
    handleOutsideClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      
      const isCalendarClick = target.closest('.calendar-drop-down-box') || 
                             target.closest('.calendar-drop-down-icon') ||
                             target.closest('.calendar-drop-down-content');
      
      if (!isCalendarClick) {
        this.closeAllCalendars();
      }
    },
    closeAllCalendars() {
      if (this.$refs.issuesRef && (this.$refs.issuesRef as any).closeCalendar) {
        (this.$refs.issuesRef as any).closeCalendar();
      }
      
      if (this.$refs.activityRef && (this.$refs.activityRef as any).closeCalendar) {
        (this.$refs.activityRef as any).closeCalendar();
      }
      if (this.$refs.chart4Ref && (this.$refs.chart4Ref as any).closeCalendar) {
        (this.$refs.chart4Ref as any).closeCalendar();
      }
    }
  },
});
</script>
